import { createContext, useContext, useState, useEffect } from "react";
import { cartLineTotal } from "@/lib/api";

const CartContext = createContext(null);
const keyOf = (productId, variant, bundleQty) => `${productId}::${variant || ""}::${bundleQty || ""}`;

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("storeig_cart")) || { handle: null, items: [] }; }
    catch { return { handle: null, items: [] }; }
  });

  useEffect(() => {
    localStorage.setItem("storeig_cart", JSON.stringify(cart));
  }, [cart]);

  // bundle = { min_qty, price } for wholesale bundle lines; null for normal single-item lines
  const addItem = (handle, product, variant = "", qty = 1, bundle = null) => {
    setCart((prev) => {
      let items = prev.handle === handle ? [...prev.items] : [];
      const k = keyOf(product.id, variant, bundle?.min_qty);
      const idx = items.findIndex((i) => keyOf(i.product.id, i.variant, i.bundle?.min_qty) === k);
      if (idx >= 0) items[idx] = { ...items[idx], quantity: items[idx].quantity + qty };
      else items.push({ product, variant, quantity: qty, bundle: bundle || null });
      return { handle, items };
    });
  };

  const setQty = (key, qty) => {
    setCart((prev) => ({
      ...prev,
      items: prev.items
        .map((i) => (keyOf(i.product.id, i.variant, i.bundle?.min_qty) === key ? { ...i, quantity: qty } : i))
        .filter((i) => i.quantity > 0),
    }));
  };

  const removeItem = (key) =>
    setCart((prev) => ({ ...prev, items: prev.items.filter((i) => keyOf(i.product.id, i.variant, i.bundle?.min_qty) !== key) }));

  const clear = () => setCart({ handle: null, items: [] });

  const count = cart.items.reduce((s, i) => s + i.quantity, 0);
  const total = cart.items.reduce((s, i) => s + cartLineTotal(i), 0);

  return (
    <CartContext.Provider value={{ cart, addItem, setQty, removeItem, clear, count, total, keyOf }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
